import { registerLinkMarkdownShortcuts } from '#pplx/frontend/composer-sdk/internal/link/registerLinkMarkdownShortcuts.js';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';
/**
 * A minimal markdown shortcut plugin that only supports link syntax [text](url).
 * This is a replacement for @lexical/react/LexicalMarkdownShortcutPlugin
 * that doesn't pull in @lexical/markdown and its heavy dependencies
 * (@lexical/code, @lexical/list, prismjs).
 */
export function LinkMarkdownShortcutPlugin() {
    const [editor] = useLexicalComposerContext();
    useEffect(() => {
        return registerLinkMarkdownShortcuts({ editor });
    }, [editor]);
    return null;
}
export default LinkMarkdownShortcutPlugin;
//# sourceMappingURL=LinkMarkdownShortcutPlugin.js.map